function broadcast(componentName, eventName, params) {
	this.$children.forEach(child => {
		var name = child.$options.name

		if (name === componentName) {
			// eslint-disable-next-line prefer-spread
			child.$emit.apply(child, [eventName].concat(params))
		} else {
			broadcast.apply(child, [componentName, eventName].concat([params]))
		}
	})
}
export default {
	methods: {
		dispatch(componentName, eventName, params) {
			var parent = this.$parent || this.$root
			var name = parent.$options.name

			while (parent && (!name || name !== componentName)) {
				parent = parent.$parent

				if (parent) {
					name = parent.$options.name
				}
			}
			if (parent) {
				// eslint-disable-next-line prefer-spread
				parent.$emit.apply(parent, [eventName].concat(params))
			}
		},
		broadcast(componentName, eventName, params) {
			broadcast.call(this, componentName, eventName, params)
		},
	},
}
